import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const MILESTONE_RECORDS_LIST_SUCCESS =
  api.events.milestoneRecordsList.actionSuccess;
const MILESTONE_RECORDS_LATEST_SUCCESS =
  api.events.milestoneRecordsLatest.actionSuccess;
const MILESTONE_RECORDS_CREATE_SUCCESS =
  api.events.milestoneRecordsPost.actionSuccess;
const MILESTONE_RECORDS_PATCH_SUCCESS =
  api.events.milestoneRecordsPatch.actionSuccess;
const MILESTONE_RECORDS_DELETE_SUCCESS =
  api.events.milestoneRecordsDelete.actionSuccess;

const milestoneRecordSchema = new schema.Entity('milestoneRecords');

const milestoneRecordListSchema = new schema.Array(milestoneRecordSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case MILESTONE_RECORDS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, milestoneRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.milestoneRecords
      };
    }
    case MILESTONE_RECORDS_LATEST_SUCCESS: {
      const normalizedData = normalize(action.data, milestoneRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.milestoneRecords
      };
    }
    case MILESTONE_RECORDS_CREATE_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case MILESTONE_RECORDS_PATCH_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case MILESTONE_RECORDS_DELETE_SUCCESS: {
      const deletedId = action.request.pathvars.id;
      return _.omit(state, [deletedId]);
    }
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/milestoneRecords.js